import PropTypes from "prop-types";
import StatCard from "./StatCard";

const getGridColumns = (count) => {
    if (count <= 1) return 1;
    if (count === 2) return 2;
    if (count === 3) return 3;
    if (count === 4) return 4;
    if (count === 5) return 5;
    // if (count === 6) return 6;

    // 7–8 cards → 4 per row
    if (count <= 8) return 4;

    // 9–10 cards → 5 per row
    if (count <= 10) return 5;

    // 11–12 cards → 6 per row
    // return 6;

    // 11–12 cards → 4 per row
    return 4;
};

const StatsGrid = ({ cards = [], gap = "20px" }) => {
    const columns = getGridColumns(cards.length);

    if (!cards.length) { return null; }

    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                gap,
                marginBottom: "24px",
                width: "100%",
                alignItems: "stretch",
            }}
        >
            {cards.map((card, index) => (
                <StatCard
                    key      = { card.id || card.title || index }
                    title    = { card.title }
                    value    = { card.value }
                    subtitle = { card.subtitle }
                    icon     = { card.icon }
                    color    = { card.color }
                    onClick  = { card.onClick }
                />
            ))}
        </div>
    );
};

StatsGrid.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),

            title: PropTypes.string.isRequired,

            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,

            subtitle: PropTypes.string,

            icon: PropTypes.string,

            color: PropTypes.string,

            onClick: PropTypes.func,
        })
    ),

    gap: PropTypes.string,
};

export default StatsGrid;
